import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="py-8 text-center text-sm border-t border-white/5" data-id="element-63">
        <p className="text-gray-600 mb-3" data-id="element-64">
          © {new Date().getFullYear()} El Efecto Sombra. Todos los derechos
          reservados.
        </p>
        <div className="flex items-center justify-center gap-4" data-id="element-65">
          <button onClick={() => setActiveModal('privacy')} className="text-gray-500 hover:text-gold-400 transition-colors duration-300 underline underline-offset-2 decoration-gray-700 hover:decoration-gold-400/50" data-id="element-66">
            Política de Privacidad
          </button>
          <span className="text-gray-700" data-id="element-67">|</span>
          <button onClick={() => setActiveModal('terms')} className="text-gray-500 hover:text-gold-400 transition-colors duration-300 underline underline-offset-2 decoration-gray-700 hover:decoration-gold-400/50" data-id="element-68">
            Términos y Condiciones
          </button>
        </div>
      </footer>

      <AnimatePresence data-id="element-69">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.25
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-70">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.3,
          ease: [0.21, 0.47, 0.32, 0.98]
        }} className="bg-dark-100 border border-gold-500/20 rounded-sm max-w-2xl w-full max-h-[80vh] overflow-y-auto shadow-[0_0_60px_rgba(0,0,0,0.8)]" onClick={e => e.stopPropagation()} data-id="element-71">
              {/* Header */}
              <div className="sticky top-0 bg-dark-100 border-b border-gold-500/10 px-6 py-4 flex items-center justify-between z-10" data-id="element-72">
                <h2 className="text-xl font-serif text-gold-400" data-id="element-73">
                  {activeModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
                </h2>
                <button onClick={() => setActiveModal(null)} className="text-gray-500 hover:text-white transition-colors p-1" aria-label="Cerrar" data-id="element-74">
                  <XIcon className="w-5 h-5" data-id="element-75" />
                </button>
              </div>

              {/* Content */}
              <div className="px-6 py-6 text-gray-400 leading-relaxed space-y-6 text-sm" data-id="element-76">
                {activeModal === 'privacy' ? <PrivacyContent data-id="element-77" /> : <TermsContent data-id="element-78" />}
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}
function PrivacyContent() {
  return <>
      <p className="text-gray-500 text-xs uppercase tracking-widest" data-id="element-79">
        Última actualización: Marzo 2026
      </p>

      <section data-id="element-80">
        <h3 className="text-white font-serif text-lg mb-2" data-id="element-81">
          1. Información que Recopilamos
        </h3>
        <p data-id="element-82">
          Recopilamos únicamente la información necesaria para procesar tu
          compra y entregarte el producto digital. Esto incluye tu nombre,
          dirección de correo electrónico y datos de pago procesados de forma
          segura a través de nuestro proveedor de pagos externo.
        </p>
      </section>

      <section data-id="element-83">
        <h3 className="text-white font-serif text-lg mb-2" data-id="element-84">
          2. Uso de la Información
        </h3>
        <p data-id="element-85">
          Tu información personal se utiliza exclusivamente para: procesar y
          confirmar tu compra, enviarte el producto digital adquirido, y
          comunicarnos contigo en caso de ser necesario respecto a tu pedido. No
          compartimos, vendemos ni alquilamos tu información personal a
          terceros.
        </p>
      </section>

      <section data-id="element-86">
        <h3 className="text-white font-serif text-lg mb-2" data-id="element-87">
          3. Protección de Datos
        </h3>
        <p data-id="element-88">
          Implementamos medidas de seguridad técnicas y organizativas para
          proteger tu información personal contra acceso no autorizado,
          alteración, divulgación o destrucción. Los pagos son procesados
          mediante plataformas seguras con encriptación SSL.
        </p>
      </section>

      <section data-id="element-89">
        <h3 className="text-white font-serif text-lg mb-2" data-id="element-90">4. Cookies</h3>
        <p data-id="element-91">
          Nuestro sitio puede utilizar cookies esenciales para garantizar su
          correcto funcionamiento y cookies analíticas para mejorar tu
          experiencia de navegación. Puedes configurar tu navegador para
          rechazar cookies en cualquier momento.
        </p>
      </section>

      <section data-id="element-92">
        <h3 className="text-white font-serif text-lg mb-2" data-id="element-93">5. Tus Derechos</h3>
        <p data-id="element-94">
          Tienes derecho a acceder, rectificar o eliminar tu información
          personal en cualquier momento. También puedes solicitar la limitación
          del tratamiento de tus datos o ejercer tu derecho a la portabilidad de
          los mismos.
        </p>
      </section>

      <section data-id="element-95">
        <h3 className="text-white font-serif text-lg mb-2" data-id="element-96">
          6. Cambios en esta Política
        </h3>
        <p data-id="element-97">
          Nos reservamos el derecho de actualizar esta política de privacidad en
          cualquier momento. Cualquier cambio será publicado en esta página con
          la fecha de actualización correspondiente.
        </p>
      </section>
    </>;
}
function TermsContent() {
  return <>
      <p className="text-gray-500 text-xs uppercase tracking-widest" data-id="element-98">
        Última actualización: Marzo 2026
      </p>

      <section data-id="element-99">
        <h3 className="text-white font-serif text-lg mb-2" data-id="element-100">
          1. Aceptación de los Términos
        </h3>
        <p data-id="element-101">
          Al acceder a este sitio web y realizar una compra, aceptas estar
          sujeto a estos términos y condiciones de uso. Si no estás de acuerdo
          con alguno de estos términos, te recomendamos no utilizar este sitio
          ni adquirir nuestros productos.
        </p>
      </section>

      <section data-id="element-102">
        <h3 className="text-white font-serif text-lg mb-2" data-id="element-103">
          2. Producto Digital
        </h3>
        <p data-id="element-104">
          "El Efecto Sombra" es un producto digital en formato PDF. Al completar
          tu compra, recibirás acceso instantáneo al material. Debido a la
          naturaleza digital del producto, este se entrega de forma inmediata y
          completa tras el pago.
        </p>
      </section>

      <section data-id="element-105">
        <h3 className="text-white font-serif text-lg mb-2" data-id="element-106">3. Uso Personal</h3>
        <p data-id="element-107">
          El contenido adquirido es para uso personal y exclusivo del comprador.
          Queda estrictamente prohibida la reproducción, distribución,
          modificación o reventa total o parcial del material sin autorización
          expresa por escrito.
        </p>
      </section>

      <section data-id="element-108">
        <h3 className="text-white font-serif text-lg mb-2" data-id="element-109">
          4. Propiedad Intelectual
        </h3>
        <p data-id="element-110">
          Todo el contenido de este sitio web y del producto digital, incluyendo
          textos, gráficos, logotipos y diseño, está protegido por derechos de
          propiedad intelectual. El uso no autorizado de cualquier material
          constituye una violación de dichos derechos.
        </p>
      </section>

      <section data-id="element-111">
        <h3 className="text-white font-serif text-lg mb-2" data-id="element-112">
          5. Limitación de Responsabilidad
        </h3>
        <p data-id="element-113">
          El contenido de "El Efecto Sombra" tiene fines informativos y
          educativos. Los resultados pueden variar según cada persona y
          situación. No garantizamos resultados específicos y no nos hacemos
          responsables de las decisiones tomadas basándose en el material
          proporcionado.
        </p>
      </section>

      <section data-id="element-114">
        <h3 className="text-white font-serif text-lg mb-2" data-id="element-115">
          6. Política de Reembolso
        </h3>
        <p data-id="element-116">
          Debido a la naturaleza digital e instantánea del producto, todas las
          ventas son finales. No se ofrecen reembolsos una vez que el acceso al
          material ha sido entregado. Te recomendamos leer toda la información
          disponible antes de realizar tu compra.
        </p>
      </section>

      <section data-id="element-117">
        <h3 className="text-white font-serif text-lg mb-2" data-id="element-118">
          7. Modificaciones
        </h3>
        <p data-id="element-119">
          Nos reservamos el derecho de modificar estos términos y condiciones en
          cualquier momento sin previo aviso. Las modificaciones entrarán en
          vigor desde su publicación en este sitio web.
        </p>
      </section>
    </>;
}